import React, { useState, useCallback } from 'react';
import Form, {
  Item,
  Label,
  RequiredRule,
  EmailRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { useAuth } from '../../contexts/auth';

import './LoginForm.scss';

export default function LoginForm() {
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '', rememberMe: false });

  const onSubmit = useCallback(async (e: any) => {
    e.preventDefault();
    const { email, password } = formData;
    setLoading(true);

    const result = await signIn(email, password);
    if (!result.isOk) {
      setLoading(false);
      notify(result.message, 'error', 2000);
    }
  }, [signIn, formData]);

  const onInput = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    const target = event.target as HTMLInputElement;
    if (target.placeholder === 'E-mail') {
      setFormData((current) => ({ ...current, email: target.value }));
    }
    if (target.placeholder === 'Senha') {
      setFormData((current) => ({ ...current, password: target.value }));
    }
  }, []);

  return (
    <form className={'login-form'} onInput={onInput} onSubmit={onSubmit}>
      <Form
        formData={formData}
        disabled={loading}
        onFieldDataChanged={(event) =>
          setFormData((current) => ({ ...current, [event.dataField!]: event.value }))
        }
      >
        <Item
          dataField={'email'}
          editorType={'dxTextBox'}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="Informe o e-mail" />
          <EmailRule message="E-mail inválido" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="Informe a senha" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'rememberMe'}
          editorType={'dxCheckBox'}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item>
      </Form>
      <button className="login-submit-button" type="submit" disabled={loading}>
        {
          loading
            ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
            : 'Entrar'
        }
      </button>
    </form>
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'E-mail', mode: 'email' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Senha', mode: 'password' };
const rememberMeEditorOptions = { text: 'Manter nesta sessão', elementAttr: { class: 'form-text' } };
